import { render, staticRenderFns } from "./ProductConfigurator.vue?vue&type=template&id=6d65d4d4&"
import script from "./ProductConfigurator.vue?vue&type=script&lang=js&"
export * from "./ProductConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./ProductConfigurator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports